/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// utils
import { url } from 'utils/urls';
// material
import { SingleSelectDropDown, Radio, IncDecField, Tip } from '@insticator/insticator-ui/dist/material';
import Space from 'material/space/space';
import { SectionGroupV2 } from 'material/expandablesection/v2'
import { ConfigToggle } from 'material/expandablesection/v2'
import PreviewConfig from 'material/previewconfig/previewconfig'
import ArticleCard from 'material/articlecard/articleccard'
import { ReactComponent as LeftArrow } from 'assets/icons/left-arrow.svg'
import { ReactComponent as RightArrow } from 'assets/icons/right-arrow.svg'
// styles
import injectSheet from 'react-jss'
import styles from './articlelayout_styles'


const displayTypeOptionList = [
  { name: 'Horizontal scroll', value: 'HORIZONTAL_SCROLL'},
  { name: 'Load more button', value: 'BUTTON'},
]

const displayTypeOption = {
  'HORIZONTAL_SCROLL': displayTypeOptionList[0],
  'BUTTON': displayTypeOptionList[1],
}

/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: GENERAL SECTION : ARTICLE LAYOUT ~~~~~~~~~~ ========== */
const ArticleLayout = injectSheet(styles)((props) => {

  const { enableSpotlight, loadMoreStyle, loadMoreUpdates, initialRowsCount, loadMoreRowsCount, onChange } = props

  const handleArticleLayoutChange = (newProperty) => {
    const currentProperties = {
      enableSpotlight,
      loadMoreStyle,
      loadMoreUpdates,
      initialRowsCount,
      loadMoreRowsCount
    }
    onChange({ layoutConfig: {...currentProperties, ...newProperty}})
  }
  const handleLoadMoreStylechange = opt => handleArticleLayoutChange({ loadMoreStyle: opt.value })

  return (
    <SectionGroupV2 
      indented={true} 
      klass={`articlelayout ${props.classes.articlelayout}`} 
      title={'Article layout'} 
      description={'Define formatting and how articles display on your page.'}
      rowGap={32} 
      direction={'column'}>
        <Space gap={48}>
          <Space gap={16} direction={'column'}>
            <ConfigToggle 
            // Rename "Spotlight" to "Featured" article TREND2-135
              title={<span> 
                Enable featured article{' '} 
                <Tip 
                  space={'none'} 
                  icon={'question-circle'} 
                  label={''} 
                  content={`Highlight an article positioned above the 1st row of articles; which is based on the “Sort by” config`} 
                />
              </span>}
              checked={enableSpotlight}
              onChange={val => handleArticleLayoutChange({ enableSpotlight: val})}
            />
            <Space direction={'column'}>
              <label>Display type</label>
              <SingleSelectDropDown 
                name={`${displayTypeOption[loadMoreStyle].name}`} 
                searchable={false} 
                onSelect={handleLoadMoreStylechange}
                items={displayTypeOptionList}
              />
            </Space>
            <div className={'loadmoreupdates'}>
              {loadMoreStyle === 'HORIZONTAL_SCROLL' ? (
                <Space direction={'column'}>
                  <span>Define how many articles shift when using arrow navigation icons.</span>
                  <Radio 
                    isList
                    title={`One Article`}
                    checked={loadMoreUpdates === 'ONE_ARTICLE'}
                    handleChange={() => handleArticleLayoutChange({ loadMoreUpdates: 'ONE_ARTICLE' })}
                  />
                  <Radio 
                    isList
                    title={`Enitre row`}
                    checked={loadMoreUpdates === 'ENTIRE_ROW'}
                    handleChange={() => handleArticleLayoutChange({loadMoreUpdates: 'ENTIRE_ROW'})}
                  />
                </Space>
              )
              :
              <Space gap={16} direction={'column'}>
                <IncDecField
                  name={'initialrowscount'}
                  label={'Number of rows visible on initial page load.'}
                  defaultValue={initialRowsCount}
                  minValue={1}
                  maxValue={10}
                  handleIncToggle={val => handleArticleLayoutChange({ initialRowsCount: val })}
                  handleDecToggle={val => handleArticleLayoutChange({ initialRowsCount: val })}
                  ctaPosition={'inline'}
                />
                <IncDecField
                  name={'loadmorerowscount'}
                  label={'Number of rows visible when clicking on "Load more articles" button.'}
                  defaultValue={loadMoreRowsCount}
                  minValue={1}
                  maxValue={10}
                  handleIncToggle={val => handleArticleLayoutChange({ loadMoreRowsCount: val })}
                  handleDecToggle={val => handleArticleLayoutChange({ loadMoreRowsCount: val })}
                  ctaPosition={'inline'}
                />
              </Space>
            }
            </div>
          </Space>
          <PreviewConfig>
            <Space gap={16} direction={'column'}> 
              <h3>Popular in the community</h3>
              {enableSpotlight && (
                <ArticleCard 
                  title={'Sample article headline from your site'} 
                  direction={'horizontal'}
                  featured
                  imageSrc={`${url.image}/2.0/trendingnow/article-image-1.jpg`}
                />
              )}
              <Space alignItems={'center'} gap={0}>
              <div className='arrowwrap'>{loadMoreStyle === 'HORIZONTAL_SCROLL' && <LeftArrow className='leftarrow' />}</div>
              <div className='container'>
                {Array(loadMoreStyle === 'HORIZONTAL_SCROLL' ? 1 : initialRowsCount).fill(0).map(() => (
                  <>
                    <ArticleCard 
                      title={'Sample article headline from your site'} 
                      imageSrc={`${url.image}/2.0/trendingnow/article-image-2.jpg`}
                    />
                    <ArticleCard 
                      title={'Sample article headline from your site'} 
                      imageSrc={`${url.image}/2.0/trendingnow/article-image-3.jpg`}
                    />
                    <ArticleCard 
                      title={'Sample article headline from your site'} 
                      imageSrc={`${url.image}/2.0/trendingnow/article-image-4.jpg`}
                    />
                  </>
                ))}
              </div>
              <div className='arrowwrap'>{loadMoreStyle === 'HORIZONTAL_SCROLL' && <RightArrow className='rightarrow' />}</div>
              </Space>
              <Space alignItems={'center'} justifyContent={'center'}>
                {loadMoreStyle === 'BUTTON' && (
                  <div className='loadmore'>Load more articles</div>
                )}
              </Space>
            </Space>
          </PreviewConfig>
        </Space>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ArticleLayout;